// extracted by mini-css-extract-plugin
export default {"messageList":"messageList_x_jI4","tips":"tips_RGyDt"};